import './SocialMasterConfigurationsPage.css';

import React, { useState } from 'react';
import { useLoginContext } from '../../../App';
import Banner from '../../b2b-common/Banner';
import SocialTemplatesTable from '../components/SocialTemplatesTable';
import SocialTemplateEditForm from '../forms/SocialTemplateEditForm';
import useTemplates from '../hooks/useTemplates';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

const SocialMasterConfigurationsPage = () => {
    const { loginData } = useLoginContext();
    const { t } = useB2BTranslation('b2b-social');

    const { templates, setTemplates, fetchingTemplates } = useTemplates(loginData);

    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [showTemplateEditForm, setShowTemplateEditForm] = useState(false);

    const handleNewTemplate = () => {
        console.log('handleNewTemplate');
        setSelectedTemplate(null);
        setShowTemplateEditForm(true);
    }

    const handleSelectTemplate = (template) => {
        // console.log('handleSelectTemplate', template);
        setSelectedTemplate(template);
        setShowTemplateEditForm(true);
    }

    const handleSavedTemplate = (savedTemplate) => { 
        // console.log('handleSavedTemplate', savedTemplate);
        setShowTemplateEditForm(false);
    
        const templateIndex = templates.findIndex(template => template.socialPostTemplateId === savedTemplate.socialPostTemplateId);
    
        if (templateIndex !== -1) {
            // Update existing template
            const updatedTemplates = [...templates];
            updatedTemplates[templateIndex] = savedTemplate;
            setTemplates(updatedTemplates);
        } else {
            // Add new template
            setTemplates([...templates, savedTemplate]);
        }
    }

    const handleDeletedTemplate = async (template) => {
        setShowTemplateEditForm(false);
        const newTemplates = templates.filter((t) => t.socialPostTemplateId !== template.socialPostTemplateId);
        setTemplates(newTemplates);
     }

    return (
        <div className="social-master-configurations-page">
            <Banner sectionTittle={t('Master Configuration')} message={t('Social Templates')} />
            <SocialTemplatesTable templates={templates} tableLoading={fetchingTemplates}
                onNewTemplate={handleNewTemplate} onSelect={handleSelectTemplate} />
            {showTemplateEditForm ? (
                <SocialTemplateEditForm template={selectedTemplate}
                    onSave={handleSavedTemplate}
                    onDelete={handleDeletedTemplate}
                    onCancel={() => setShowTemplateEditForm(false)}
                />
            ) : null
            }
        </div>
    );
}

export default SocialMasterConfigurationsPage;